import { DbTable } from "./DbTable";
import { Company } from "../../models/company.model";
import { Injectable } from "@angular/core";
import { BankAccount, Category } from "../../models/bank-account.model";
import { PaymentType, RelCompanyPaymentType, RelPurchaseProduct } from '../../models/payment-type.model';
import { Profile } from '../../models/profile.model';
import { License } from '../../models/license.model';
import { Vendor } from '../../models/vendor.model';
import { Product } from "../../models/product.model";
import { Employee } from '../../models/employee.model';
import { HttpClient } from '@angular/common/http';


export class DbBankAccounts extends DbTable<BankAccount> {


      constructor(public _http: HttpClient)  {
          super(_http, "BankAccounts");
      }
    
}


export class DbPaymentTypes extends DbTable<PaymentType> {


      constructor(public _http: HttpClient)  {
          super(_http, "PaymentTypes");
      }
    
}

export class DbRelCompanyPaymentTypes extends DbTable<RelCompanyPaymentType> {

    constructor(public _http: HttpClient, public _companyId:number)  {

        super(_http, `Companies/${_companyId}/PaymentTypes`);

    }
  
}

export class DbRelPurchaseProducts extends DbTable<RelPurchaseProduct> {

    constructor(public _http: HttpClient, public id:number)  {

        super(_http, `purchases/${id}/products`);

    }
  
}


export class DbLicenses extends DbTable<License> {

    constructor(public _http: HttpClient, public _customerId:number)  {

        super(_http, `Customers/${_customerId}/Licenses`);

    }
  
}


export class DbCategories extends DbTable<Category> {


    constructor(public _http: HttpClient)  {
        super(_http, "Categories");
    }
  
}

export class DbVendors extends DbTable<Vendor> {


    constructor(public _http: HttpClient)  {
        super(_http, "vendors");
    }
  
}

export class DbEmployees extends DbTable<Employee> {


    constructor(public _http: HttpClient)  {
        super(_http, "employees");
    }
  
}

export class DbProfiles extends DbTable<Profile> {

    constructor(public _http: HttpClient)  {
        super(_http, "Profiles");
    }
  
}

export class DbProducts extends DbTable<Product> {

    constructor(public _http: HttpClient)  {
        super(_http, "products2");
    }
  
}